module.exports = __webpack_public_path__ + "static/mention_03-2dd919bccfa39158e908787fcd46f983.png";